import { PhysicalComplaintsDashboard } from './PhysicalComplaintsDashboard'

export default PhysicalComplaintsDashboard
